import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import { EditAcquisitionForm } from "../Forms";
import { Acquisition } from "@/types";

interface EditAcquisitionModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  defaultFormData: Acquisition;
  caseInfo: { case_id: number };
  evidenceInfo?: { evidence_id: number; case_id?: number };
}

export const EditAcquisitionModal: FC<EditAcquisitionModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultFormData,
  caseInfo,
  evidenceInfo,
}) => {
  const handleSubmit = () => {
    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <EditAcquisitionForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        defaultFormData={defaultFormData}
        caseInfo={caseInfo}
        showEvidenceSelector={!!!evidenceInfo}
        width={550}
      />
    </Modal>
  );
};
